var typePath = "spark.element.type";

var basePath = function basePath(name) {
  return "".concat(typePath, ".").concat(name);
};

export default {
  headings: {
    fontFamily: 'heading',
    fontWeight: 'base',
    lineHeight: 'sm',
    mt: 0,
    mb: '0.5em'
  },
  H1: {
    variant: basePath('headings'),
    fontSize: ['xl', 'xxl', 'xxxl']
  },
  H2: {
    variant: basePath('headings'),
    fontSize: ['lg', 'xl', 'xxl']
  },
  H3: {
    variant: basePath('headings'),
    fontSize: ['md', 'lg', 'xl']
  },
  H4: {
    variant: basePath('headings'),
    fontSize: ['sm', 'md', 'lg']
  },
  H5: {
    variant: basePath('headings'),
    fontSize: ['xs', 'sm', 'md'],
    fontWeight: 'semiBold'
  },
  H6: {
    variant: basePath('headings'),
    fontSize: ['xxs', 'xs', 'sm'],
    fontWeight: 'semiBold'
  },
  subtitles: {
    fontFamily: 'heading',
    fontWeight: 'base',
    lineHeight: 'sm'
  },
  S1: {
    variant: basePath('subtitles'),
    fontSize: 'md'
  },
  S2: {
    variant: basePath('subtitles'),
    fontSize: 'sm'
  },
  S3: {
    variant: basePath('subtitles'),
    fontSize: 'xs'
  },
  body: {
    fontFamily: 'body',
    fontWeight: 'base',
    lineHeight: 'md'
  },
  Body1: {
    variant: basePath('body'),
    fontSize: 'sm'
  },
  Body2: {
    variant: basePath('body'),
    fontSize: 'xs'
  },
  Body3: {
    variant: basePath('body'),
    fontSize: 'xxs'
  },
  bold: {
    fontWeight: 'bold'
  },
  Bold1: {
    variant: basePath('bold'),
    fontSize: 'sm'
  },
  Bold2: {
    variant: basePath('bold'),
    fontSize: 'xs'
  },
  Bold3: {
    variant: basePath('bold'),
    fontSize: 'xxs'
  },
  buttons: {
    fontFamily: 'base',
    fontWeight: 'semiBold',
    lineHeight: 'sm'
  },
  Button1: {
    variant: basePath('buttons'),
    fontSize: 'xs'
  },
  Button2: {
    variant: basePath('buttons'),
    fontSize: 'xxs'
  },
  Button3: {
    variant: basePath('buttons'),
    fontSize: 'xxxs'
  },
  inputs: {
    fontFamily: 'base',
    fontWeight: 'base',
    lineHeight: 'sm'
  },
  Input1: {
    variant: basePath('inputs'),
    fontSize: 'sm'
  },
  Input2: {
    variant: basePath('inputs'),
    fontSize: 'xs'
  },
  Input3: {
    variant: basePath('inputs'),
    fontSize: 'xxs'
  },
  hyperlinks: {
    fontFamily: 'base',
    fontWeight: 'base',
    lineHeight: 'sm',
    textDecoration: 'underline'
  },
  Hyperlink1: {
    variant: basePath('hyperlinks'),
    fontSize: 'sm'
  },
  Hyperlink2: {
    variant: basePath('hyperlinks'),
    fontSize: 'xs'
  },
  Hyperlink3: {
    variant: basePath('hyperlinks'),
    fontSize: 'xxs'
  },
  Caption: {
    fontSize: 'xxxs',
    lineHeight: 'sm'
  },
  Overline: {
    textTransform: 'uppercase',
    fontSize: 'xxxxs',
    letterSpacing: '0.15em',
    lineHeight: 'sm'
  }
};